import { render } from "./MenusPageQr.vue?vue&type=template&id=a00c4670&scoped=true"
import script from "./MenusPageQr.vue?vue&type=script&lang=js"
export * from "./MenusPageQr.vue?vue&type=script&lang=js"

import "./MenusPageQr.vue?vue&type=style&index=0&id=a00c4670&scoped=true&lang=css"

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-76db364fbb/3/buildhome/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00c4670"]])

export default __exports__